// 商品物料映射管理
URL = {
	list:"/ebus/materialrelatemage/materialrelate/select",//商品物料映射管理-查询商品物料映射列表
	add:"/ebus/materialrelatemage/materialrelate/add",//商品物料映射管理-添加商品物料映射
	edit:"/ebus/materialrelatemage/materialrelate/modify",//商品物料映射管理-修改商品物料映射
	find:"/ebus/materialrelatemage/materialrelate/find",//商品物料映射管理-查询商品物料映射
	del:"/ebus/materialrelatemage/materialrelate/delete",//商品物料映射管理-删除商品物料映射
	restore:"/ebus/materialrelatemage/materialrelate/restore"//商品物料映射管理-恢复已删除商品物料映射
}

/**
 * 加载线上商品信息
 * @param {回调函数} cb 
 */
async function queryOnlineGoods(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.list,data);
  if(cb&&resResult){
    let treeData
    if (resResult.status && resResult.data.list) {    
      cb(resResult);
    } else {
      cb([]);
    }
  }else{
    cb([]);
  }
}

/**
 * 提交商品关联物料
 */
async function submitMtrl2GoodsRelate(data,cb) {
  debugger;
  if(!data){
    return;
  }
  let response = await this.$post(URL.edit, data);
  if (response.status && response.data) {
    cb(response)
  } else {
    cb(response);
  }
}

export default {
  queryOnlineGoods,
  submitMtrl2GoodsRelate
}